import request from '../request';
import qs from 'qs'

/**
 * 获取第一层工作包进度
 */
export const getProjectPackagesAPI = async(projectID: number | string): Promise<API.Project.Package[]> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/progress-data`);
};

/**
 * 获取合同进度
 */
export const getProjectContractStagesAPI = async (projectID: number | string): Promise<API.ListData<API.PROJECT.ListItem>> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/progress-stages`);
};

/**
 * 获取仪表盘项目信息
 */
export const getProjectProgressAPI = async (id: number | string): Promise<API.Project.Dashboard> => {
    return await request.get(`/workbenchApi/cockpits/projects/${id}/progresses`);
};

/**
 * 获取仪表盘信息
 */
export const getProjectDashboardAPI = async (projectID: number | string): Promise<API.Project.Dashboard> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/progress-dashboards`);
};

/**
 * 获取人员负荷信息
 */
export const getDashboardWorktimeAPI = async (projectID: number | string): Promise<API.Project.DashboardWorktime> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/member-load`);
};

/**
 * 获取指定人员负荷详情
 */
export const getMemberWorktimeDetailAPI = async (projectID: number | string, params: Req.DashboardWorktimeDetail): Promise<API.Project.DashboardWorktimeDetail> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/member-load/detail`, {
        params
    });
};

/**
 * 获取成本分析汇总
 */
export const getDashboardCostTotalAPI = async (projectID: number | string, departs: string[], type: string): Promise<API.Project.DashboardCostTotal> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/cost-analysis-info?${params}&type=${type}`);
};

/**
 * 获取成本分析图表
 */
export const getDashboardCosDataAPI = async (projectID: number | string, departs: string[]): Promise<API.Project.DashboardCostItem[]> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/cost-analysis?${params}`);
};

/**
 * 获取仪表盘成本分析部门
 */
export const getDashboardCosMajorsAPI = async (projectID: number | string): Promise<API.Project.DashboardCostMajor[]> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/cost-analysis-majors`);
};
/**
 * 获取仪表盘项目效率
 */
export const getDashboardEfficiencyAPI = async (projectID: number | string, deptCodes: string): Promise<API.Project.DashboardEfficiency> => {
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/benefit-parameters?deptCodes=${deptCodes}`);
};


/***************项目管控节点线*****************/
export const createControlNodeLineAPI = async (projectID: number | string, data: Request.ControlNodeLineParams): Promise<API.Project.DashboardEfficiency> => {
    return await request.post(`/workbenchApi/integrateds/projects/${projectID}/lines`, data);
};
export const updateControlNodeLineMilestoneTimeAPI = async (lineId: number): Promise<{}> => {
    return await request.patch(`/workbenchApi/integrateds/lines/${lineId}/update-milestone-time`);
};
export const updateControlNodeLineAPI = async (lineId: number | string, data: Request.ControlNodeLineParams): Promise<API.Project.DashboardEfficiency> => {
    return await request.put(`/workbenchApi/integrateds/lines/${lineId}`, data);
};
export const getControlNodeLinesAPI = async (projectID: number | string): Promise<API.PROJECT.ControlNodeLine[]> => {
    return await request.get(`/workbenchApi/integrateds/projects/${projectID}/lines`);
};
export const getControlNodeLineDetailAPI = async (lineId: number | string): Promise<API.PROJECT.ControlNodeLine> => {
    return await request.get(`/workbenchApi/integrateds/lines/${lineId}`);
};
export const deleteControlNodeLineAPI = async (lineId: number | string): Promise<API.PROJECT.ControlNodeLine> => {
    return await request.delete(`/workbenchApi/integrateds/lines/${lineId}`);
};
export const getControlNodeAllStatusAPI = async (): Promise<API.PROJECT.ControlNodeStatus[]> => {
    return await request.get(`/workbenchApi/integrateds/lines/status`);
};
export const getTHPaymentNodesAPI = async (projectID: number | string): Promise<API.PROJECT.ContractExpense[]> => {
    return await request.get(`/workbenchApi/integrateds/projects/${projectID}/payment-nodes`);
};
export const updateControlNodeStatusAPI = async (nodeId: number | string, status: number): Promise<API.PROJECT.ControlNodeStatus[]> => {
    return await request.patch(`/workbenchApi/integrateds/nodes/${nodeId}/status`, { status });
};
export const updateControlLineSortAPI = async (projectID: number | string, lineIds: (number | string)[]): Promise<null> => {
    return await request.patch(`/workbenchApi/integrateds/projects/${projectID}/lines/sort`, { lineIds });
};
export const getControlTemplateNodesAPI = async (templateID: number | string): Promise<API.PROJECT.ControlTemplateNode[]> => {
    return await request.get(`/workbenchApi/integrateds/templates/${templateID}/nodes`);
};
export const uploadFileInControlNodeAPI = async (nodeId: number | string, data: FormData): Promise<API.PROJECT.ControlNodeStatus[]> => {
    return await request.post(`/workbenchApi/integrateds/nodes/${nodeId}/upload`, data);
};
export const deleteFileInControlNodeAPI = async (fileId: number | string): Promise<null> => {
    return await request.delete(`/workbenchApi/integrateds/nodes/files/${fileId}`);
};
export const getFilesInControlNodeAPI = async (nodeId: number | string): Promise<API.DDSFile[]> => {
    return await request.get(`/workbenchApi/integrateds/nodes/${nodeId}/files`);
};
// 获取工程相同的项目
export const getEngineeringProjectsAPI = async (projectID: number | string): Promise<API.PROJECT.EngineeringProject[]> => {
    return await request.get(`/workbenchApi/integrateds/projects/${projectID}/engineering-projects`);
};
// 导入到同工程项目里程碑
export const importMilestoneToProjectAPI = async (projectID: number | string, thirdPartyProjectId: number | string): Promise<API.PROJECT.EngineeringProject[]> => {
    return await request.post(`/workbenchApi/integrateds/projects/${projectID}/bind-milestone`, {
        thirdPartyProjectId
    });
};
// 外协交圈线
export const getTechnicalSpecialLineAPI = async (projectID: number | string): Promise<API.PROJECT.TechnicalSpecialLineItem[]> => {
    return await request.get(`/workbenchApi/integrateds/projects/${projectID}/technical-special-project-alert-light`);
};

//-------------------------------------
// 项目总览
export const getProjectOwnerDashboardAPI = async (projectID: number | string, departs: string[]): Promise<API.Project.DashboardProjectOverview> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    return await request.get(`/workbenchApi/cockpits/projects/${projectID}/project-owner-dashboard?${params}`);
};
export const getProjectWorktimeMonthlyStatisticsAPI = async (projectID: number | string, departs: string[]): Promise<API.Project.DashboardProjectWorktime[]> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    const url = `/workbenchApi/cockpits/projects/${projectID}/worktime/monthly/statistics?${params}`
    return await request.get(url);
};
export const getProjectEmployeeWorkloadsAPI = async (projectID: number | string, departs: string[]): Promise<API.Project.DashboardUserWorkloads[]> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    const url = `/workbenchApi/cockpits/projects/${projectID}/employee-workloads?${params}`
    return await request.get(url);
};
// 人员投入工时曲线
export const getProjectWorktimeCurveDataAPI = async (projectID: number | string, departs: string[]): Promise<API.Project.DashboardWorktimeCurveData[]> => {
    const params = qs.stringify({ deptCodes: departs }, { arrayFormat: 'repeat' })
    const url = `/workbenchApi/cockpits/projects/${projectID}/worktime/curve-data?${params}`
    return await request.get(url);
};